import React from 'react'
import styled from 'styled-components'

import Button from 'components/lib/DesignSystem/Button'
import { FillWarning } from 'components/lib/DesignSystem/Icons'
import Input from 'components/lib/DesignSystem/Input'

class TeamsFourthStep extends React.Component {
  handleStepRedirect = (changeInIndex) => {
    this.props.changeWizardIndex(this.props.wizardIndex + changeInIndex)
  }

  handleEditUrl = (e) => this.props.updateWebhookUrl(e.target.value)

  handleCompleteIntegration = () => this.props.updateNotifications()

  isValidWebhookUrl = (url) => {
    // Safety checks
    if (!url || typeof url !== 'string') {
      return false
    }

    try {
      // Parse the URL to validate it's a proper URL
      const parsedUrl = new URL(url)

      // Check if it's HTTPS (security requirement)
      if (parsedUrl.protocol !== 'https:') {
        return false
      }

      const validDomains = [
        '.office.com/webhook', // classic Teams
        '.office.com/webhookb2', // new Teams
        '.logic.azure.com', // Logic Apps (Consumption)
        '.environment.api.powerplatform.com', // Power Automate Direct (commercial)
        '.powerplatform.us', // Power Automate Direct (US Gov)
        '.powerplatform.de', // Power Automate Direct (Germany)
        '.powerplatform.cn', // Power Automate Direct (China)
        '.azurewebsites.net', // Azure Functions / Logic App Standard
      ]

      // Check if the hostname contains any of the valid domains
      return validDomains.some((domain) => parsedUrl.hostname.includes(domain))
    } catch (error) {
      // If URL parsing fails, it's not a valid URL
      // Log the error for debugging purposes while still returning false
      console.warn('Invalid webhook URL provided:', error.message)
      return false
    }
  }

  render() {
    const { className, error, webhookUrl, permissions, isStaticSalesDemo } = this.props

    return (
      <div className={className}>
        <img
          src={`${STATIC_BASE_URL}/static/webapp/images/settings/teams-step-4.png`}
          style={{ width: '563px', height: '370px' }}
        />
        <div className="actions-container">
          <div>
            <div className="number-indication">1</div>
            <span className="text-indication">
              Copy the workflow's URL and paste it below. Note that you can always copy it from the
              Home tab in the
              <b> Workflows </b>
              Teams page.
            </span>
            <div className="url-container">
              <Input
                id="Settings_NotificationsTeams_FourthStep_URL_input"
                placeholder="Paste URL"
                value={webhookUrl}
                onChange={this.handleEditUrl}
                meta={{
                  error: error?.detail,
                  touched: Boolean(error),
                  icon: <FillWarning />,
                }}
              />
            </div>
            <div className="mt">
              <div className="number-indication">2</div>
              <span className="text-indication">Click on “Done”</span>
            </div>
          </div>
        </div>
        <div className="buttons-container">
          <Button
            text="Back"
            styleType="secondary"
            onClick={() => this.handleStepRedirect(-1)}
            className="smr"
            id="teams-backButton"
          />
          {/* TODO:Change the includes text after 3 months to webhook.office.com/webhook 14/01/2021 */}
          <Button
            text="Complete Integration"
            disabled={
              !webhookUrl ||
              !this.isValidWebhookUrl(webhookUrl) ||
              !permissions.admin ||
              isStaticSalesDemo
            }
            onClick={this.handleCompleteIntegration}
            className="sml"
            id="teams-completeIntegrationButton"
          />
        </div>
      </div>
    )
  }
}

export default styled(TeamsFourthStep)`
  .url-container {
    margin: 15px 25px;
  }
  .buttons-container {
    margin-top: ${(props) => (props.error ? '30px' : '63px')};
  }
`
